import { ApiCheckIsAdmin, ApiDeleteUser, ApiGetUserById, ApiGetUserList, ApiRegister, ApiUpdateUser } from "utils/constants/api";
import useFetch from "utils/hooks/useFetch";
import { useModal } from 'context/ModalContext'
import { CheckResponse } from "utils/helpers";

export function UserService() {
    const { showFail } = useModal()

    const { fetch: apiGetUserList } = useFetch(ApiGetUserList)
    const { fetch: apiDeleteUser } = useFetch(ApiDeleteUser)
    const { fetch: apiCheckIsAdmin } = useFetch(ApiCheckIsAdmin)
    const { fetch: apiRegisterUser } = useFetch(ApiRegister)
    const { fetch: apiUpdateUser } = useFetch(ApiUpdateUser)
    const { fetch: apiGetUserById } = useFetch(ApiGetUserById)

    const fetchInsertUser = async (username, fullName, password, isAdmin) => {
        const res = await apiRegisterUser({
            data: {
                username,
                fullName,
                password,
                isAdmin
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateUser = async (userId, username, fullName, password, isAdmin) => {
        const res = await apiUpdateUser({
            data: {
                userId,
                username,
                fullName,
                password,
                isAdmin
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUserById = async (userId) => {
        const res = await apiGetUserById({
            data: {
                userId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUserList = async (username, name, status, pageSize, pageIndex) => {
        const res = await apiGetUserList({
            data: {
                username,
                name, 
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteUser = async (userId, status) => {
        const res = await apiDeleteUser({
            data: {
                userId,
                status
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCheckIsAdmin = async (userId) => {
        const res = await apiCheckIsAdmin({
            data: {
                userId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return { 
        fetchInsertUser,
        fetchUpdateUser,
        fetchUserById,
        fetchUserList,
        fetchDeleteUser,
        fetchCheckIsAdmin
    }
}